import { Column, Columns, Tag, TagProps } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { ReactNode } from 'react';
import styled from 'styled-components';

const StyledTagIcon = styled.div`
  display: flex;
`;

interface IconTagProps extends Omit<TagProps, 'variant'> {
  icon: ReactNode;
  variant?: TagProps['variant'];
}

export function IconTag({ children, icon, ...props }: IconTagProps) {
  return (
    <Tag variant="subtle" {...props}>
      <Columns space="xxsmall" align="center">
        <Column width="content">
          <StyledTagIcon>
            <TextBox variant="body-semibold" color="inherit">
              {icon}
            </TextBox>
          </StyledTagIcon>
        </Column>

        <Column width="fluid">
          <TextBox variant="body-semibold" color="inherit">
            {children}
          </TextBox>
        </Column>
      </Columns>
    </Tag>
  );
}
